import html_logo from "../Images/html_logo.png"
import css_logo from "../Images/CSS_logo.svg"
import js_logo from "../Images/JavaScript_Logo.png"
import react_logo from "../Images/React_logo.jpg"
import redux_logo from "../Images/Redux_logo.png"
import materialUi_logo from "../Images/materialUi_logo.png"
import styledCom_logo from "../Images/styledCom_logo.png"
import MongoDB_logo from "../Images/MongoDB_logo.gif"
import express_logo from "../Images/express_logo.png"
import mongoose_logo from "../Images/mongoose_logo.png"
import github_logo from "../Images/github.png"
import nodejs_logo from "../Images/nodejs.png"
import npmlogo from "../Images/npm_logo.png"
import developerImage from "../Images/developer_Image.jpg"

const imgData = [
    html_logo, css_logo, js_logo, react_logo, redux_logo, 
    MongoDB_logo, mongoose_logo , github_logo, nodejs_logo
    ,express_logo,npmlogo
]

export {imgData, developerImage} 